module.exports = __webpack_public_path__ + "img/shuiyin.3c7091c2.png";